import React, { useState,useEffect } from 'react';
import { View,Dimensions,Animated } from 'react-native';
import CView from './CView';
import CInput from './CInput';
import CDatePicker from './CDatePicker';
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from 'rn-responsive-styles';
import moment from 'moment';
import CustomButton from './CustomButton';
import ModalAlert from './ModalAlert';
import CustomInput from './CustomInput';
import CText from './CText';

export default function CPanDetails(props) {
  const styles = useStyles();
  const isSmallDevice = Dimensions.get("window").width < 767;
  const namePattern = /^(?=.*[A-Za-z]{3})[A-Za-z\s]+$/
  const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/

  const type = props?.type || '';
  const isPanAutheniticated = props?.isPanAutheniticated;
  const isError = props?.isError || false

  const [fullName, setFullName] = useState('');
  const [dob, setDob] = useState('');
  const [panNumber, setPanNumber] = useState('');
  const [isPanValidated, setIsPanValidated] = useState(false);

  useEffect(()=>{
    if(isError){
      setFullName("")
      setDob("")
      setPanNumber("")
    }
  },[isError])

  const onSubmit = () => {
    let date = moment(dob).format('DD/MM/YYYY')
    props.onSubmit({ panNumber: panNumber, fullName: fullName, dob: date });
  };

  const handleDob = (val) => {
    setDob(val)
  };

  const disableButton = () => {
    
    let disable = true;
    if(type==""){
      if (panNumber!=="" && fullName !== '' && dob !== '') {
        if(namePattern.test(fullName) && panPattern.test(panNumber)){ disable = false;}
      }
    }else{
      if (panNumber && fullName !== '' && dob !== '') {
        if(namePattern.test(fullName) && panPattern.test(panNumber)){ disable = false;}
      }
    }
    
    return disable;
  };

  const renderUclPan = () => {
    return (
      <>
        <CView
          FR
          GAP={10}>
          <View>
              <CText.inputTopLabel>
              Your Permanent Account Number(PAN)<Animated.Text style={[styles.inlineError, { color: '#f00', fontSize: 15, fontWeight: '500' }]}>{' *'}</Animated.Text>
              </CText.inputTopLabel>
              <CustomInput
                value={panNumber.toUpperCase()}
                onValueChanged={(e) => setPanNumber(e)}
                onValidation={(isValid) => setIsPanValidated(isValid)}
                maxLength={10}
                inputType='alpha-numeric'
                pattern={/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                errorMessage={'Please enter valid pan'}
                style={{ width: 230,marginTop:10 }}
                editable={!isPanAutheniticated}

              />
            </View>
            <View>
              <CText.inputTopLabel>
              Your full name (As per PAN)<Animated.Text style={[styles.inlineError, { color: '#f00', fontSize: 15, fontWeight: '500' }]}>{' *'}</Animated.Text>
              </CText.inputTopLabel>
              <CustomInput
                value={fullName.toUpperCase()}
                onValueChanged={(e) => setFullName(e)}
                maxLength={40}
                pattern={/^(?=.*[A-Za-z]{3})[A-Za-z\s]+$/}
                errorMessage={'Please enter valid Name'}
                style={{ width: 230,marginTop:10}}
                editable={!isPanAutheniticated}

              />
            </View>
          <View style = {{marginTop:-7}}>
            <CDatePicker
             isMobile={isSmallDevice}
              style={{ width: 230}}
              mandatoryField={true}
              label={'Your date of birth (As per PAN)'}
              value={dob}
              onDateChange={(val) => handleDob(val)}
              editable={isPanAutheniticated}
              
            />
            </View>
        </CView>

        <View style={styles.footer}>
          <CustomButton
            onPress={disableButton()? () => {}: isPanAutheniticated ?  ()=>{} :onSubmit }
            disable={disableButton()}
            text={isPanAutheniticated ? 'Validated' : 'Validate'}
            backgroundColor={isPanAutheniticated ? 'green'  : '#bd2d37'}
          />
        </View>
      </>
    );
  };
  const renderKyc =()=>{
    return (
      <>
        <CView
          FR
          style={styles.fullWidth}>
          <View style={styles.contentSpaceInput}>
            <View>
              <CText.inputTopLabel>
              Your Permanent Account Number(PAN)<Animated.Text style={[styles.inlineError, { color: '#f00', fontSize: 15, fontWeight: '500' }]}>{' *'}</Animated.Text>
              </CText.inputTopLabel>
              <CustomInput
                value={panNumber.toUpperCase()}
                onValueChanged={(e) => setPanNumber(e)}
                onValidation={(isValid) => setIsPanValidated(isValid)}
                maxLength={10}
                inputType='alpha-numeric'
                pattern={/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                errorMessage={'Please enter valid pan'}
                style={{ width: 230 }}
              />
            </View>
            <View>
              <CText.inputTopLabel>
              Your full name (As per PAN)<Animated.Text style={[styles.inlineError, { color: '#f00', fontSize: 15, fontWeight: '500' }]}>{' *'}</Animated.Text>
              </CText.inputTopLabel>
              <CustomInput
                value={fullName.toUpperCase()}
                onValueChanged={(e) => setFullName(e)}
                maxLength={40}
                pattern={/^(?=.*[A-Za-z]{3})[A-Za-z\s]+$/}
                errorMessage={'Please enter valid Name'}
                style={{ width: 230 }}
              />
            </View>

          </View>
        </CView>
        <CView FR>
          <View style={styles.contentSpaceInput}>
          <CDatePicker
             isMobile={isSmallDevice}
              style={{ width: 230,marginTop:0 }}
              mandatoryField={true}
              label={'Your date of birth (As per PAN)'}
              value={dob}
              onDateChange={(val) => handleDob(val)}
              disable={!isPanAutheniticated}
            />
            <View style={styles.submitButton}>
              <CustomButton
                text={'Submit'}
                onPress={disableButton() ? '' : onSubmit}
                disable={disableButton()}
              />
            </View>
          </View>
        </CView>
      </>
    );
  }
  return (
    <>
      {type === 'ucl' ? (
        renderUclPan()
      ) : type == 'kycUpdate' ? (
        renderKyc()
      ) : (
        <>
          <CView
            FR
            style={styles.fullWidth}>
            <View style={styles.contentSpaceInput}>
              <View></View>
              <CustomInput
                flexDirection={styles.inputStyle.flexDirection}
                label={'Your Permanent Account Number(PAN)'}
                value={panNumber.toUpperCase()}
                onValueChanged={(e) => setPanNumber(e)}
                onValidation={(isValid) => setIsPanValidated(isValid)}
                maxLength={10}
                inputType='alpha-numeric'
                pattern={/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/}
                errorMessage={"Please enter valid pan"}
                style={styles.inputStyle}
                disable={!isPanValidated}
                mandatoryField   = {true}
              />
              <CustomInput
                flexDirection={styles.inputStyle.flexDirection}
                label={'Your full name (As per PAN)'}
                value={fullName.toUpperCase()}
                onValueChanged={(e) => setFullName(e)}
                maxLength={40}
                pattern={/^(?=.*[A-Za-z]{3})[A-Za-z\s]+$/}
                errorMessage={'Please enter valid Name'}
                style={styles.inputStyle}
                mandatoryField   = {true}
              />
              
            </View>
          </CView>
          <CView FR>
            <View style={styles.contentSpaceInput}>
            <CDatePicker
             isMobile={isSmallDevice}
              style={{ width: 230,marginTop:0 }}
              mandatoryField={true}
              label={'Your date of birth (As per PAN)'}
              value={dob}
              onDateChange={(val) => handleDob(val)}
              disable={!isPanAutheniticated}
            />
              <View style={styles.submitButton}>
                <CustomButton
                  text={'Proceed to KYC Verification'}
                  onPress={disableButton()? ()=>{} :onSubmit}
                  disable={disableButton()}
                />
              </View>
            </View>
          </CView>
        </>
      )}
    </>
  );
}
const useStyles = CreateResponsiveStyle(
  {
    footer: {
      flexDirection: 'row',
      alignSelf: 'flex-end',
      width: 220,
      height: 44,
      top:-10
    },
    submitButton: {
      width: 250,
      height: 35,
      top: 20,
    },
    overlayViewStyle: {
      position: 'absolute',
      zIndex: 9999,
      backgroundColor: 'rgba(52,52,52,0.9)',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    fullWidth: {
      width: '100%',
    },
    contentSpace: {
      flex: 0.5,
    },
    contentSpaceInput: {
      minWidth: 500,
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'start',
    },
   
    verifiedText: {
      position: 'relative',
      right: 85,
      flexDirection: 'row',
    },
    inputStyle: {
      flexDirection: 'column',
      marginTop:8
    }
  },

  {
    [maxSize(DEVICE_SIZES.LG)]: {},

    [maxSize(DEVICE_SIZES.MD)]: {
     
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      
      closurePolicyWidget: {
        minHeight: 130,
        paddingVertical: 8,
      },
      closurePolicyText: {
        fontSize: 13,
        maxWidth: 200,
      },
      contentWidget: {
        paddingLeft: 20,
      },
      navWidget: {
        flexDirection: 'column',
      },
      msgWidget: {
        flexDirection: 'column',
      },
      msgInnerCnt: {
        width: '100%',
        flex: 1,
      },
      msgInnerCntTag: {
        width: '100%',
        flex: 1,
        minHeight: 170,
      },
      bankCntInner: {
        width: '100%',
      },
      selectedCard: {
        minHeight: 100,
      },
      backTextDesc: {
        paddingLeft: 20,
        paddingRight: 0,
        fontSize: 10,
      },
      contentSpaceInput: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      overlayViewStyle: {
        left: 0,
      },
      overlayContentViewStyle: {
        width: '100%',
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        marginLeft: 0,
        width: '100%',
        maxWidth: '100%',
      },
      closurePolicyWidget: {
        minHeight: 130,
        paddingVertical: 8,
      },
      closurePolicyText: {
        fontSize: 14,
        maxWidth: 180,
      },
      contentWidget: {
        paddingLeft: 20,
      },
      navWidget: {
        flexDirection: 'column',
      },
      msgWidget: {
        flexDirection: 'column',
      },
      msgInnerCnt: {
        width: '100%',
        flex: 1,
      },
      msgInnerCntTag: {
        width: '100%',
        flex: 1,
        minHeight: 170,
      },

      bankCntInner: {
        width: '100%',
      },
      selectedCard: {
        minHeight: 100,
      },
      backTextDesc: {
        paddingLeft: 20,
        paddingRight: 0,
        fontSize: 10,
      },
      contentSpaceInput: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      overlayViewStyle: {
        left: 0,
      },
      overlayContentViewStyle: {
        width: '100%',
      },
      cancelChequeWidget: {
        marginLeft: -10,
      },
    },
  }
);
